import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import { useSFX } from 'js/hooks/useSFX';

// import selectors
import { getTranslationById } from 'js/store/app/App.selectors';
import { getUserCollections } from 'js/store/collections/Collections.selectors';

// import components
import ButtonTickState from 'js/components/button/Button.tick-state';
import ButtonWithIcon from 'js/components/button/Button.with-icon';
import Thumbnail from 'js/components/thumbnail/Thumbnail';

// import actions
import { createCollection } from 'js/store/collections/Collections.actions';

// import helpers
import { uuid } from 'js/utils/uuid';
import { trackEvent } from '../../../utils/tracking';

const CollectionCreate = ({ card, closeModal }) => {
  const siteText = {
    create: useSelector((state) => getTranslationById(state, 'overlay_popup_create', 'Create')),
    selectNameForGallery: useSelector((state) =>
      getTranslationById(state, 'overlay_popup_select_a_name_for_your_gallery', 'Select a name for your gallery')
    ),
    createGalleryButtonText: useSelector((state) =>
      getTranslationById(state, 'overlay_popup_create_gallery_button_text', 'Create Gallery')
    ),
  };

  const { playSFX } = useSFX();
  const dispatch = useDispatch();
  const [nameIndex, setNameIndex] = React.useState(false);
  const { largeImage = '', title = '' } = card?.front || {};

  const userCollectionNames = useSelector((state) => getUserCollections(state).map((collection) => collection.name));

  const triggerCreation = () => {
    if (nameIndex === false) return;

    const uuidValue = uuid();
    dispatch(
      createCollection({
        id: uuidValue,
        name: `gallery_name_${nameIndex}`,
        cards: [card.id],
      })
    );
    trackEvent('game_collection_create', { collection_id: uuidValue });
    closeModal();
  };

  return (
    <div className="collection-modal__create">
      <h1>{siteText.create}</h1>

      <div
        style={{
          textAlign: 'center',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Thumbnail src={largeImage} alt={title} />
      </div>

      <h3 style={{ marginBottom: 20 }}>{siteText.selectNameForGallery}</h3>
      <OverlayScrollbarsComponent
        className="custom-scrollbar collection-modal__create__names"
        style={{ height: '32vh', maxHeight: '300px' }}
      >
        {Array.from({ length: 5 }, (_, index) => {
          if (!userCollectionNames.includes(`gallery_name_${index + 1}`)) {
            return (
              <div
                key={index}
                onClick={() => {
                  setNameIndex(index + 1);
                  playSFX('button_tap');
                }}
                className={`collection-modal__create-name ${nameIndex === index + 1 ? 'active' : ''}`}
                style={{
                  padding: '5px 5px 5px 15px',
                  border: '2px solid #ffffffff',
                  borderRadius: '40px',
                  margin: '0px 25px 10px',
                  background: nameIndex === index + 1 ? '#F7EBB1' : 'transparent',
                  color: nameIndex === index + 1 ? '#003764' : '#fff',
                  cursor: 'pointer',
                  textAlign: 'start',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                {useSelector((state) => getTranslationById(state, `gallery_name_${index + 1}`, `Gallery ${index + 1}`))}
                <ButtonTickState selected={nameIndex === index + 1} style={{ marginLeft: 'auto' }} />
              </div>
            );
          }
        })}
      </OverlayScrollbarsComponent>

      {userCollectionNames.length < 5 && (
        <ButtonWithIcon
          title={siteText.createGalleryButtonText}
          iconName={'tick'}
          iconPosition={'right'}
          style={{
            backgroundColor: '#9DC145',
            borderRadius: '36px',
            margin: 'auto',
            marginTop: '30px',
            padding: '15px 20px 15px 50px',
            fontSize: 14,
          }}
          disabled={nameIndex === false}
          action={triggerCreation}
        />
      )}
    </div>
  );
};

export default CollectionCreate;
